import React from 'react';
import { FormProvider } from 'react-hook-form';
import { useLoginModal } from './hooks';
import { LoginModalPresentation } from './presentations';

export const LoginModal: React.FC = () => {
  const {
    state: { methods, errMsg, buttonDisabled },
    actions: { handleSubmit },
  } = useLoginModal();

  return (
    <FormProvider {...methods}>
      <LoginModalPresentation
        title='ログイン'
        onSubmit={handleSubmit}
        errorMessage={errMsg}
        buttonDisabled={buttonDisabled}
        emailPlaceholder='merchant@example.com'
      />
    </FormProvider>
  );
};
